import type { LegendItem } from '../../core/components/legend/categorical/types/legend.js';

export interface HoneycombOverlayState {
  toolbarVisible: boolean;
}

export interface HoneycombSelectionState {
  hovered: LegendItem | undefined;
}

export interface HoneycombState {
  selection: HoneycombSelectionState;
  overlay: HoneycombOverlayState;
}

export const initialState: HoneycombState = {
  selection: {
    hovered: undefined,
  },
  overlay: {
    toolbarVisible: false,
  },
};
